import { SUCCESSFUL_GET_ACCOUNT, SUCCESSFUL_GET_ACCOUNT_BALANCE } from "./actionConst";

const initialState = {
    info: {
        balance: "",
        transactions: []
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_ACCOUNT:
            return {
                ...state,
                info: action.payload
            }
        case SUCCESSFUL_GET_ACCOUNT_BALANCE:
            state.info.balance = action.payload.amount;
            let newInfo = Object.assign({}, state.info);
            return {
                ...state,
                info: newInfo
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/account/accountReducer.js